import Box, { BoxProps } from '@material-ui/core/Box';
import * as React from 'react';

import Layer from '../models/Layer';
import MapLayer from './MapLayer';

export interface Props {
  toggleLayer: (layerId: string) => void;

  layers: Layer[];
}

const Layers: React.FC<Props & BoxProps> = ({ toggleLayer, layers, ...boxProps }) => {
  return (
    <Box display="flex" flexDirection="column" py={1} px={2} overflow="hidden auto" {...boxProps}>
      {layers.map(layer => {
        return <MapLayer key={layer.key} onLayerToggle={toggleLayer} layer={layer} />;
      })}
    </Box>
  );
};

export default Layers;
